import { cn } from '@/helpers/utils/functionality-utils';
import { useTranslation } from '@/hooks/useTranslation';
import { Button, type ButtonProps } from 'primereact/button';

interface FooterTemplateProps {
  loading: boolean;
  onCancel: () => void;
  submitBtnRef?: React.RefObject<HTMLButtonElement | null>;
  onClick?: () => void;
  saveLabel?: string;
  saveIcon?: string;
  cancelProps?: ButtonProps;
  submitProps?: ButtonProps;
  footerClassName?: string;
  rightContent?: React.ReactNode;
}
export const DialogFooterTemplate = ({
  loading,
  onCancel,
  submitBtnRef,
  onClick,
  saveLabel = 'save',
  saveIcon = 'pi pi-check',
  cancelProps,
  submitProps,
  footerClassName,
  rightContent = <div />,
}: FooterTemplateProps) => {
  const { t } = useTranslation('common');
  return (
    <div
      className={cn(
        `mt-4 flex items-center justify-between gap-4 sm:mt-2`,
        footerClassName,
      )}
    >
      {rightContent}
      <div className={'mt-4 flex items-center justify-end gap-4 sm:mt-0'}>
        <Button
          severity="secondary"
          icon="pi pi-times mr-2"
          outlined
          onClick={() => onCancel?.()}
          type="button"
          {...cancelProps}
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={() => {
            if (typeof onClick === 'function') {
              onClick();
            } else {
              submitBtnRef?.current?.click();
            }
          }}
          loading={loading}
          icon={saveIcon}
          severity="success"
          type="submit"
          {...submitProps}
        >
          <span className="ml-2">{t(saveLabel)}</span>
        </Button>
      </div>
    </div>
  );
};
